import Alert from '@material-ui/lab/Alert';
import { IconButton, Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

const warning = "NB! You need to have VPN running to call API endpoints"
const reasonProxied = "because this UI is proxies all the requests through an endpoint that is not available without VPN"
const reasonBenefits = "The benefit of using proxy is that all the services with OpenAPI definitions don't need to configure CORS to allow requests from Backstage for this Backstage Swagger UI"

export const VpnWarning = () => (
  <Alert severity="warning">
    {warning} ({reasonProxied})
    <Tooltip
      title={reasonBenefits}>
      <IconButton size="small">
        <InfoIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </Alert>
);
